module.exports = __webpack_public_path__ + "img/clock.d770f446.svg";